import { CssBaseline } from '@mui/material'
import { ErrorBoundary } from 'react-error-boundary'
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom'
import { Navigate } from 'react-router-dom'

import { MainView, PageWrapper } from '@/components/index'
// import { Credentials } from '@/pages'
import { AppRoutes } from '@/routes/index'

import { InboxManagementContextProvider } from './context/InboxContext'

import './App.css'
interface ErrorFallbackProps {
  error: Error
  resetErrorBoundary: () => void
}

function ErrorFallback({ error, resetErrorBoundary }: ErrorFallbackProps) {
  return (
    <div role="alert">
      <p>Something went wrong:</p>
      <pre>{error.message}</pre>
      <button onClick={resetErrorBoundary}>Try again</button>
    </div>
  )
}

function App() {
  return (
    <div className="App">
      <CssBaseline />
      <ErrorBoundary FallbackComponent={ErrorFallback}>
        <Router>
          <Routes>

            <Route
              path="/*"
              element={
                <PageWrapper>
                  <InboxManagementContextProvider>
                    <MainView>
                      <AppRoutes />
                    </MainView>
                  </InboxManagementContextProvider>
                </PageWrapper>
              }
            />
          </Routes>
        </Router>
      </ErrorBoundary>
    </div>
  )
}

export default App
